import React from 'react';
import { findDOMNode } from 'react-dom';
import { isMobile } from "react-device-detect";
import { TimelineLite } from 'gsap';

export default {

    initiate(title, formBtn, leadCopy) {
        this.tl = new TimelineLite({paused: true});

        title = findDOMNode(title);
        formBtn = findDOMNode(formBtn);

        if (isMobile) {
            this.tl.fromTo(title, 0.5, {opacity: 0}, {opacity: 1}, 0);
            this.tl.fromTo(leadCopy, 0.5, {y: 50, opacity: 0}, {y: 0, opacity: 1, visibility: 'visible'}, 0.5);
        } else {
            this.tl.fromTo(title, 1.5, {y: -100, opacity: 0}, {y: 0, opacity: 1, delay: 1, ease: Back.easeOut.config(1.5)});
            this.tl.fromTo(leadCopy, 1.5, {y: 100, opacity: 0}, {y: 0, opacity: 1, ease: Back.easeOut.config(1.5)}, 1);
            this.tl.fromTo(formBtn, 0.5, {x: 100, opacity: 0}, {x: 0, opacity: 1}, '=-1');
        }
    },

    play() {
        this.tl.play();
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/HeroHome/animations.js